import type { TaskPriority } from '@gokrew/models/tasks';
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ChevronsUpIcon,
  MinusIcon,
} from 'lucide-react';
import { Chip } from '@/components/Chip';
import { Tone } from '@gokrew/models/ui.types';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';

const PRIORITY_CONFIG: Record<
  TaskPriority,
  { tone: Tone; Icon: typeof ArrowUpIcon }
> = {
  low: { tone: Tone.SECONDARY, Icon: ArrowDownIcon },
  medium: { tone: Tone.WARNING, Icon: MinusIcon },
  high: { tone: Tone.ACCENT, Icon: ArrowUpIcon },
  urgent: { tone: Tone.ERROR, Icon: ChevronsUpIcon },
};

interface TaskPriorityChipProps {
  priority: TaskPriority;
}

export function TaskPriorityChip({ priority }: TaskPriorityChipProps) {
  const { t } = useTranslation(TranslationNS.LibsCommon);
  const config = PRIORITY_CONFIG[priority] ?? PRIORITY_CONFIG.medium;
  const { Icon } = config;

  return (
    <Chip
      type={config.tone}
      size="sm"
      className="inline-flex items-center gap-1 w-fit"
    >
      <Icon size={10} />
      {t(`tasks.priority.${priority}`)}
    </Chip>
  );
}
